import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=fe4a311c&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=fe4a311c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4a311c",
  null
  
)

export default component.exports